import {
  Component,
  Input,
  ChangeDetectionStrategy,
  Inject,
  PLATFORM_ID,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter
} from '@angular/core';
import { environment } from '@env/environment';
import { Product } from '@vestiaire/api-sdk-angular';
import { isPlatformServer } from '@angular/common';
import { I18nData } from '@app/core/i18n/services';
import { HostnameLocalizationService } from '@app/core/i18n';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import { LikeSuccess } from '@app/+product/store';
import { AlgoliaInsightService } from '../services/algolia-insight.service';

@Component({
  selector: 'vc-catalog-snippet',
  templateUrl: './catalog-snippet.component.html',
  styleUrls: ['./catalog-snippet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogSnippetComponent implements OnChanges {
  @Input()
  product: Product;
  @Input()
  index: number;
  @Input()
  likedItem: string[] = [];
  @Input()
  eventToObserve: Event;
  @Input()
  lazyOff: boolean;
  MinImageLazyLoaded = 3;
  imgixPath;
  @Input()
  seoContext: string[] = [];
  @Input()
  queryId: string;
  @Input()
  indexName: string;
  @Output()
  eventManager = new EventEmitter<any>();

  isServer = false;
  sellerRatingActivated = environment.feature.seller_rating; // TODO remove config when active
  public expertSellerBadge = false;
  public trustedSellerBadge = false;
  public isLocationEnable = false;
  public hostName = '';

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    public hostnameLocalizationService: HostnameLocalizationService,
    private store: Store<IAppState>,
    public i18nData: I18nData,
    public algoliaInsightService: AlgoliaInsightService
  ) {
    this.imgixPath = environment.imgixPath;
    this.isServer = isPlatformServer(this.platformId);
    this.hostName = this.hostnameLocalizationService.getHostname();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.isServer && changes.product && changes.product.currentValue.isoCountry) {
      this.isLocationEnable = true;
    } else {
      this.isLocationEnable = false;
    }

    if (
      this.sellerRatingActivated &&
      changes.product &&
      changes.product.currentValue.seller &&
      changes.product.currentValue.seller.sellerRating &&
      changes.product.currentValue.seller.sellerRating.badge
    ) {
      const badge = changes.product.currentValue.seller.sellerRating.badge;
      this.expertSellerBadge = badge === 'Expert';
      this.trustedSellerBadge = badge === 'Trusted';
    }
  }

  get isLiked(): boolean {
    if (!Array.isArray(this.likedItem)) {
      return false;
    }
    return this.likedItem.includes(String(this.product.id));
  }

  hasSeo(item: string): boolean {
    return this.seoContext.indexOf(item) > 0;
  }

  likeSuccess(value: Boolean) {
    if (value === true) {
      this.store.dispatch(new LikeSuccess(this.product));
    }
  }

  clickProduct(event) {
    this.eventManager.emit({
      positions: [this.index + 1],
      objectIDs: [this.product.id.toString()]
    });
    this.algoliaInsightService.addClickedProduct(this.product.id.toString(), this.indexName, this.queryId);
  }

  get isDirectShipping() {
    return this.product && this.product.flags && this.product.flags.includes('direct-shipping');
  }
}
